<template>
  <div
    :class="`unassigned-event-${event.id} cursor-pointer`"
    @click="handleClick"
  >
    <AppointmentEventComponent :event="eventProp" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";

import { AppointmentEvent, TimelineEvent } from "@/typings/scheduler";
import AppointmentEventComponent from "./AppointmentEvent.vue";

const props = defineProps<{
  event: TimelineEvent;
  calendar: any;
  ghost?: boolean;
}>();
onMounted(() => {
  if (!props.ghost) {
    props.calendar?.draggable(`.unassigned-event-${props.event.id}`, {
      dragData: props.event
    });
  }
});
const eventProp = computed<AppointmentEvent>(() => {
  return {
    ...props.event,
    original: { details: { ...props.event.details, is_ghost: props.ghost } }
  };
});
const handleClick = () => {
  window.handleSchedulerEventEdit(props.event.details.appointment?.id);
};
</script>
